import React from "react";
import {
  FaGlobe,
  FaMobile,
  FaNetworkWired,
  FaQuestionCircle,
} from "react-icons/fa";
import { SiProgress, SiMdnwebdocs } from "react-icons/si";
import Titles from "../layouts/Titles";
import Card from "./Card";

const MyFeatures = () => {
  return (
    <section
      id="features"
      className="w-full py-20  border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Titles title="Features" des="What I Do👁️" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-20">
        <Card
          title="Networking Engineering"
          des="I'm a Network Engineer by profession & I'm pursuing a Bachelor of Science in 
          Computer Network Engineering at the University of Malawi. "
          icon={<FaNetworkWired />}
        />
        <Card
          title="Mobile & Desktop App Development"
          des="I develop mobile applications using the flutter 
            framework and dart programming language.
            I also do develop Desktop applications using Java  language."
          icon={<FaMobile />}
        />
        <Card
          title="Questionaire Programming "
          des="It's always my pleasure to program questionnaires into a digitized way of
           collecting data using mobile phones such as tablets etc."
          icon={<FaQuestionCircle />}
        />
        <Card
          title="Web Development & Hosting"
          des="Learning to code is useful no matter what your career ambitions are. 
          I develop and deploy the websites so that people can be able to see my work.."
          icon={<FaGlobe />}
        />
        <Card
          title="Graphic Design"
          des="I started a graphic design career in 2021 & this is my daily work. 
          You may follow me on Facebook to check out my work. Click the link below."
          link={
            <a href="https://m.facebook.com/people/Macheda-Graphics/100083311030390/">
              Macheda Graphics{" "}
            </a>
          }
          icon={<SiMdnwebdocs />}
        />
        <Card
          title="ZuzuTech Shop"
          des="ZuzuTech is my Tech company. Within the company hierarchy, I have a tech shop containing
           different products such as Laptops, desktops, phones,
           Bluetooth speakers, etc. I order all products from South Africa."
          icon={<SiProgress />}
        />
      </div>
    </section>
  );
};

export default MyFeatures;
